import Avatar, { AvatarSize } from '@app/src/components/Ui/Avatar'
import { DescriptionOutlined } from '@mui/icons-material'
import { ButtonBase, Stack, Tooltip, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import React, { useState } from 'react'
import type { TextTruncateProps } from 'react-text-truncate'
import TextTruncate from 'react-text-truncate'
import ParentCellOrFragment from './ParentCellOrFragment'

export interface RequestCellProps {
  title: string
  onClick?: () => void
  imageUrl?: string
  tooltipText?: string
  maxRows?: TextTruncateProps['line']
  disableCell?: boolean
  isLoading?: boolean
  hideAvatar?: boolean
  isScraped?: boolean | false
  disabled?: boolean
}

const RequestCell: React.FC<RequestCellProps> = ({
  title,
  imageUrl,
  onClick,
  tooltipText,
  maxRows = 1,
  disableCell,
  isLoading,
  hideAvatar,
  isScraped,
  disabled,
}) => {
  const [truncated, setTruncated] = useState(false)

  const handleTruncate = () => {
    setTruncated(true)
  }

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <Tooltip title={truncated ? title : tooltipText}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          component={onClick && !isLoading ? ButtonBase : 'span'}
          onClick={onClick && !isLoading ? onClick : undefined}
          data-testid="request-cell"
          width="100%"
        >
          {isLoading ? (
            <CircularProgress size={20} />
          ) : hideAvatar ? null : isScraped ? (
            <DescriptionOutlined
              sx={({ palette }) => ({
                color: disabled ? palette.grey[600] : palette.communication.dark,
              })}
            />
          ) : (
            <Avatar src={imageUrl} size={AvatarSize.Small} sx={{ background: 'white' }}>
              <DescriptionOutlined
                color="primary"
                fontSize="medium"
                sx={({ palette }) => (disabled ? { color: palette.grey[600] } : {})}
              />
            </Avatar>
          )}
          <Typography
            variant="body1"
            align="left"
            sx={{
              '&:hover': { textDecoration: onClick && !isLoading ? 'underline' : 'none' },
            }}
            color={disabled ? 'textSecondary' : 'textPrimary'}
            flexGrow={1}
            component="span"
          >
            <TextTruncate line={maxRows} text={title} onTruncated={handleTruncate} data-testid="request-cell-text" />
          </Typography>
        </Stack>
      </Tooltip>
    </ParentCellOrFragment>
  )
}

export default RequestCell
